<template>
    <div class="main-container">
        <div class="main-content">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
    export default {
        name: "MainView",
        data() {
            return {}
        }
    }
</script>

<style scoped lang="less">
    .main-container {
        width: 100%;
        height: 100%;
        overflow: auto;
        padding: 20px;
        background-color: #f0f2f5;
        box-sizing: border-box;
    }

    .main-content {
        min-height: 100%;
        background: white;
        border-radius: 8px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        overflow: hidden;
    }

    /* 响应式设计 */
    @media screen and (max-width: 768px) {
        .main-container {
            padding: 15px;
        }
    }

    @media screen and (max-width: 576px) {
        .main-container {
            padding: 12px;
        }
    }
</style>
